import { maxLength, required, email, compare, password, pattern, minLength, or } from '@rxweb/reactive-form-validators';

export class RegisterModel {
  @required({ message: 'Este campo es obligatorio.' })
  @maxLength({
    value: 255,
    message: 'El correo no puede exceder los 255 caracteres.',
  })
  @or({
      validation: {
        email:  { message: "Ingrese una dirección de correo válida." },
        pattern: {
          expression: {
            alphaNumeric: /^3[0-9]{9}$/,
          },
          message: "El número no es válido.",
        }
      },
      message: "El número de celular o el correo electrónico no son válidos."
  })
  email: string;

  @required({ message: 'Este campo es obligatorio. ' })
  @password({
    validation: {
      minLength: 8,
      maxLength: 25,
      digit: true,
      //specialCharacter: true,
      lowerCase: true,
      //upperCase: true,
    },
    message: {
      minLength:
        'La contraseña debe tener al menos 8 caracteres, incluyendo una minúscula y un número.',
      maxLength: 'La contraseña debe tener máximo 25 caracteres. ',
      digit: 'La contraseña debe incluir al menos un número.',
      /* specialCharacter:
        'La contraseña debe incluir al menos un carácter especial (*#+!%$"?).', */
      lowerCase: 'La contraseña debe incluir al menos una letra minúscula.',
      //upperCase: 'La contraseña debe incluir al menos una letra mayúscula.',
    },
  })
  password: string;

  @required({ message: 'Este campo es obligatorio.' })
  @maxLength({
    value: 25,
    message: 'La contraseña debe tener máximo 25 caracteres.',
  })
  @compare({
    fieldName: 'password', // Campo a comparar
    message:
      'Las contraseñas no coinciden.',
  })
  passwordConfirm: string; // Nuevo campo para confirmación

  @required({ message: 'Este campo es obligatorio.' })
  @maxLength({
    value: 25,
    message: 'El nombre no puede exceder los 25 caracteres.',
  })
  @pattern({
    expression: {
      alphaNumeric: /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑüÜ\s]*$/,
    },
    message: 'El nombre solo puede contener letras y números.',
  })
  name: string;

  @required({ message: 'Este campo es obligatorio.' })
  @maxLength({
    value: 25,
    message: 'El apellido no puede exceder los 25 caracteres.',
  })
  @pattern({
    expression: {
      alphaNumeric: /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑüÜ\s]*$/,
    },
    message: 'El apellido solo puede contener letras y números.',
  })
  lastname: string;

  @required({ message: 'Debes aceptar los términos y condiciones.' })
  termsAccepted: boolean;
}